<template>
  <!-- 联系我们页面 -->
  <div class="call">
    <!-- 头部 -->
     <head-nav :selectedId="5"></head-nav>
    <img src="../assets/images/banner07.png" alt=""  style="width:100%"/>
    <!-- 主体 -->
    <el-container>
      <el-aside width="100%">
        <title-com :name="'联系我们'" :letter="'CONTACT US'"></title-com>
        <el-row class="fbox">
          <div class="box">
            <div class="logo">
               <img src="@/assets/images/icon_add.png" alt="" />
            </div>
            <p>地址</p>
            <div class="address" >
              陕西省西安市锦业二路 <br />逸翠商务公馆2栋2单元4层
            </div>
          </div>
          <div class="box">
            <div class="logo">
               <img src="@/assets/images/icon_call.png" alt="" />
            </div>
            <p>电话</p>
            <div class="bluetext" >029-88813806</div>
          </div>
          <div class="box">
            <div class="logo">
              <img src="@/assets/images/icon_mail.png" alt="" />
            </div>
            <p style="margin-bottom: 10px">邮箱</p>
            <div class="bluetext">sale@xaljdz.cn</div>
            <!-- <p style="margin-bottom: 10px">传真</p>
            <div class="bluetext">029-88813806-8015</div> -->
          </div>
        </el-row>
      </el-aside>
    </el-container>
    <!-- 尾部 -->
    <footer-com />
  </div>
</template>

<script>
import headNav from "@/components/header.vue";
import footerCom from "@/components/footer.vue";
import titleCom from "@/components/title.vue";
export default {
  components: {
    headNav,
    footerCom,
    titleCom,
  },
};
</script>

<style lang="scss" scoped>
.el-container {
  margin: 40px 100px;
  .fbox {
    margin-top: 200px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .box {
      margin-bottom: 102px;
      width: 500px;
      padding: 0 2%;
      height: 450px;
      background: #ffffff;
      box-shadow: -1px 7px 13px 0px rgba(24, 24, 24, 0.11);
      .logo {
        width: 200px;
        height: 200px;
        // background: #000;
        // border-radius: 50%;
        position: relative;
        top: -100px;
        left: calc(50% - 100px);
        // margin-bottom: 50px;
      }
      p {
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #2f2f2f;
        line-height: 48px;
        margin-bottom: 20px;
      }
      .bluetext {
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #3660d9;
        line-height: 36px;
        font-size: 30px;
      }
      .address{
         font-family: Source Han Sans CN;
        font-weight: 500;
        color: #3660d9;
        line-height: 36px;
        font-size: 28px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/contactUs.vue